import * as React from 'react';
import { cn } from '@/lib/utils';

const MetricNews = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-metric-news', 'relative w-full rounded-lg bg-white p-8 shadow-[0px_4px_10px_rgba(68,43,140,0.05)] xl:max-w-[432px]', className)}
    {...props}
  />
));
MetricNews.displayName = 'MetricNews';

const MetricNewsHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-metric-news-header', 'm-[12px_0_8px] block', className)}
    {...props}
  />
));
MetricNewsHeader.displayName = 'MetricNewsHeader';

const MetricNewsHeaderTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-metric-news-header-title', 'mb-0 text-lg font-bold text-primary-dark', className)}
    {...props}
  />
));
MetricNewsHeaderTitle.displayName = 'MetricNewsHeaderTitle';

const MetricNewsHeaderPoints = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-metric-news-header-points', 'mb-0 flex justify-between gap-3 text-sm text-neutral', className)}
    {...props}
  />
));
MetricNewsHeaderPoints.displayName = 'MetricNewsHeaderPoints';

const MetricNewsCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-metric-news-card',
      'relative w-full bg-white shadow-[0px_4px_10px_rgba(68,_43,_140,_0.05)] transition duration-75 hover:shadow-[0px_4px_20px_rgba(68,_43,_140,_0.25)]',
      'flex border border-solid border-neutral-lightest p-2',
      'flex grow cursor-default items-center justify-between gap-3 rounded-md',
      className
    )}
    {...props}
  />
));
MetricNewsCard.displayName = 'MetricNewsCard';

const MetricNewsCardText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-metric-news-card-text', 'mb-0 text-sm', className)}
    {...props}
  />
));
MetricNewsCardText.displayName = 'MetricNewsCardText';

const MetricNewsCardFigure = React.forwardRef(({ className, ...props }, ref) => (
  <figure
    ref={ref}
    className={cn('c-metric-news-card-figure', 'flex h-[60px] min-w-[50px] flex-col items-center justify-center rounded-lg bg-[#F1F5FA] p-[3px]', className)}
    {...props}
  />
));
MetricNewsCardFigure.displayName = 'MetricNewsCardFigure';

const MetricNewsCardCaption = React.forwardRef(({ className, ...props }, ref) => (
  <figcaption
    ref={ref}
    className={cn('c-metric-news-card-caption', 'text-[10px] font-bold text-[#5D6A86]', className)}
    {...props}
  />
));
MetricNewsCardCaption.displayName = 'MetricNewsCardCaption';

const MetricNewsCardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-metric-news-card-content', 'flex items-center gap-[10px]', className)}
    {...props}
  />
));
MetricNewsCardContent.displayName = 'MetricNewsCardContent';

export { MetricNews, MetricNewsHeader, MetricNewsHeaderTitle, MetricNewsHeaderPoints, MetricNewsCard, MetricNewsCardText, MetricNewsCardFigure, MetricNewsCardCaption, MetricNewsCardContent };
